import { render, staticRenderFns } from "./Acumulus.vue?vue&type=template&id=4f444eb4&"
import script from "./Acumulus.vue?vue&type=script&lang=js&"
export * from "./Acumulus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports